import styled from 'styled-components'

export const StyledLogo = styled.h1`
  font-size: 1.625rem;
  font-weight: var(--regular);
  letter-spacing: 0.15rem;
  text-transform: uppercase;
`
